import { useNavigate } from "react-router-dom";
import emailjs from 'emailjs-com'
import React, { useState, useEffect } from 'react';
import JsonData from "../../data/data.json";
import { Services } from '../services'
import { Header } from "../header";
import { Helmet } from "react-helmet";
import { CallRibbon } from "../callribbon";
import StatsCounter from "../StatsCounter";
import { Disclaimer } from "../disclaimer";
import { Benfit } from "../benfits";
import { GetInTouch } from "../getintouch";

const initialState = {
  from_name: '',
  mobile: '',
  status: '',
  purpose: '',
  adress: '',
}


export const RefrigeratorService = (props) => {
  const [{ from_name, purpose, mobile, status, adress }, setState] = useState(initialState)
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    window.scrollTo(0, 0);
    setLandingPageData(JsonData);
  }, []);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const validateMobile = (mobile) => {
    const regex = /^\d{10}$/; // Regex for 10 digit mobile number
    return regex.test(mobile);
  };


  const clearState = () => setState({ ...initialState })


  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateMobile(mobile)) {
      alert("Please enter a valid 10-digit mobile number.");
      return;
    }
    console.log(from_name, status, purpose, mobile, adress)
    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID, process.env.REACT_APP_EMAILJS_TEMPLATE_ID, e.target, process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          alert('Your Call Back Request has been submitted , you will get a get from our team within 5-10 min. Thanks for your patience')
          clearState();
          window.location.reload();
          navigate("/");
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  const canonicalUrl = "https://homeservesindia.com/ro";

  return (
    <div id='refrigeratorpage'>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Home Serves India Repair Service @ 9960095385 | Water Purifier Repair</title>
        <meta name="keywords" content="ro service in hyderabad, water purifier service in hyderabad" />
        <meta name="author" content="Service Center Hyderabad service is best ro repair and maintanancce service in india" />
        <meta name="description" content="RO Repair Service: We are India's leading water purifier repair and maintanance service provider of all brands like Kent, Pureit, Livpure, Aqua Guard, Aqua Fresh etc. AC repair service in Hyderabad" ></meta>
      </Helmet>
      <div className="bnr rgbnr">
        <div className="row align-items-center text-center">
          <div className="col-xs-12 col-md-6 bnrcon">
            <div className="hero-banner">
              <div className="hero-content">
                <h1>Refrigerator</h1>
                <h2>Repair Service</h2>
                <a href="#services" className="hero-button">Learn More</a>
              </div>
            </div>
          </div>


          <div className='col-xs-12 col-md-6'>
            <div className='row formsmctrl'>
              <div className='section-title'>
                <h2>SUBMIT A CALL BACK REQUEST</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='from_name'
                        className='form-control'
                        placeholder='Name*'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>

                      <select className="form-select form-control" id='purpose' name='purpose' aria-label="Purpose" onChange={handleChange} >
                        <option value="single-door"> Single-Door </option>
                        <option value="double-door"> Double-Door </option>
                        <option value="bottom-freezer"> Bottom-Freezer </option>
                        <option value="side-by-side"> Side-by-Side </option>
                        <option value="mini-fridges"> Mini-Fridges </option>
                        <option value="Deep-fridges"> Deep-Fridges </option>
                        <option selected value="refridgerator"> Other</option>
                      </select>

                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='number'
                        id='mobile'
                        name='mobile'
                        className='form-control'
                        placeholder='Mobile Number* (10-digit)'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <select className="form-select form-control" id='status' name='status' aria-label="Status" onChange={handleChange} >
                        <option value="inwarranty">In Warranty / AMC </option>
                        <option selected value="outwarranty">Out of Warranty </option>
                      </select>
                      <p className='help-block text-danger'></p>

                    </div>
                  </div>
                </div>


                <div className='form-group'>
                  <textarea
                    name='adress'
                    id='adress'
                    className='form-control'
                    rows=''
                    placeholder='Address'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg' style={{ marginLeft: '20px' }}>
                  Get a Call Back From Us
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <section id="acabout" className="acabout">
        <div className="about">
          <div className="container accon">
            <div className="row acrow">
              {/* Left Column: Image */}
              <div className="col-xs-12 col-md-6 aboutimage">
                <img
                  src="img/about.jpeg"
                  className="img-responsive"
                  alt="ro-repair-service-about-us"
                />
              </div>

              {/* Right Column: Text */}
              <div className="col-xs-12 col-md-6 acabout-text">
                <h2>About Us</h2>
                <p>
                  Home Serves India is a trusted provider of professional home appliance repair, installation, and maintenance services across India. We specialize in RO Water Purifiers, Air Conditioners, Refrigerators, Washing Machines, Microwaves, and other essential household appliances, delivering reliable doorstep solutions through our team of trained technicians.
                </p>

                <p>
                  Our mission is to provide fast, affordable, and high-quality services that keep your appliances performing at their best. From routine maintenance and installations to complex repairs, we ensure every service is completed with precision, transparency, and customer satisfaction in mind.
                </p>

                <p>
                  With a strong commitment to excellence, innovation, and dependable support, Home Serves India has become the preferred choice for thousands of customers seeking professional appliance care. We are dedicated to making your home more comfortable, convenient, and worry-free.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="acabout" className="acabout">
        <div className="about">
          <div className="container accon">
            <div className="row acrow">
              <h2 className="about2h2">Creating a safe and comfortable environment in every space.</h2>

              {/* Left Column: Text */}
              <div className="col-xs-12 col-md-6 acabout-text">
                <p>
                  At Service Center Hyderabad, we ensure your water is always pure and safe with our expert RO services. Our regular maintenance improves water quality, prevents system issues, and keeps your purifier running efficiently. We prioritize your health and comfort, offering reliable solutions customized to meet your needs.
                </p>
                <div className="roimg2">
                  <div className="row">
                    <div className="col-sm-12 col-md-6 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/clock.png" alt="ro repair in hyderabad" />
                        </div>
                        <div className="icontext">
                          <h5>Get Repair within 4 hours</h5>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/guarantee-v2.png" alt="ro service in hyderabad" />
                        </div>
                        <div className="icontext">
                          <h5>30 Day Repair Guarantee</h5>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/insurance.png" alt="ro repair in hyderabad" />
                        </div>
                        <div className="icontext">
                          <h5>Only Genuine Spare Parts</h5>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/price.png" alt="kent customer number" />
                        </div>
                        <div className="icontext">
                          <h5>Fixed Rate for spare parts</h5>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/service-v2.png" alt="ro customer care number" />
                        </div>
                        <div className="icontext">
                          <h5>4,000+ Service Request Completed</h5>
                        </div>
                      </div>
                    </div>

                    <div className="col-sm-12 col-md-6">
                      <div className="whymrwater">
                        <div className="imgicon">
                          <img src="img/wedo/trained.png" alt="ro phone number in hyderabad" />
                        </div>
                        <div className="icontext">
                          <h5>Expert & Professional Technicians</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column: Image */}
              <div className="col-xs-12 col-md-6 aboutimage ab2">
                <img
                  src="img/serviceimg/ro/1.png"
                  className="img-responsive"
                  alt="ro-repair-service-about-us"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Services data={landingPageData.RefrigeratorServices} />
      <StatsCounter />
      <Benfit data={landingPageData.BenfitsRG} />
      <Disclaimer />

      <GetInTouch />
      <CallRibbon data={landingPageData.Roribbon} />

    </div>
  )
}
